module.exports = __webpack_public_path__ + "img/2018-4.fb56a555.jpg";